import { useForm, useFormContext } from 'react-hook-form';

import { FACT_AGGREATION_METHOD } from '@/api/rest/resources/types/fact';
import { INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_TYPE } from '@/api/rest/resources/types/IndicatorProduct';

export const FORM_FIELDS = {
  INDICATOR_NAME: 'indicatorName',
  AGGREGATION_METHOD: 'aggregationMethod',
  TEMPLATE: 'template',
  TYPE: 'type',
} as const;

export const DEFAULT_FORM_VALUES = {
  [INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_TYPE.MEDIA_MAP]: {
    [FORM_FIELDS.INDICATOR_NAME]: '',
    [FORM_FIELDS.AGGREGATION_METHOD]: undefined,
    [FORM_FIELDS.TEMPLATE]: undefined,
    [FORM_FIELDS.TYPE]: INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_TYPE.MEDIA_MAP,
  },
  [INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_TYPE.DEFAULT]: {
    [FORM_FIELDS.INDICATOR_NAME]: '',
    [FORM_FIELDS.AGGREGATION_METHOD]: FACT_AGGREATION_METHOD.WEIGHTED_AVG,
    [FORM_FIELDS.TEMPLATE]: null,
    [FORM_FIELDS.TYPE]: INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_TYPE.DEFAULT,
  },
};

export type InSituDataControlsFormFieldValues = {
  [FORM_FIELDS.INDICATOR_NAME]: string;
  [FORM_FIELDS.AGGREGATION_METHOD]: (typeof FACT_AGGREATION_METHOD)[keyof typeof FACT_AGGREATION_METHOD];
  [FORM_FIELDS.TEMPLATE]: File | null;
  [FORM_FIELDS.TYPE]: (typeof INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_TYPE)[keyof typeof INDICATOR_PRODUCT_SUBSCRIPTION_CONFIGURATION_TYPE];
};

export const useControlsFormInSituData = useForm<InSituDataControlsFormFieldValues>;
export const useControlsContextInSituData = useFormContext<InSituDataControlsFormFieldValues>;
